import { fork, put } from 'redux-saga/effects';

import { ApiActions } from '../actions';
import error from './error';
import watchersSaga from './watchers';

export default function* apiSaga() {
  yield fork(error);

  yield fork(watchersSaga);

  yield put(ApiActions.auth.cachedTokenVerified(false));

  yield put(ApiActions.auth.cachedTokenVerified(true));
}
